export const TABLE_MAP = [
  { id: 1, name: "Table 1", position: { x: 350, y: 100 } },
  { id: 2, name: "Table 2", position: { x: 50, y: 100 } },
  { id: 3, name: "Table 3", position: { x: 205, y: 50 } },
  { id: 4, name: "Table 4", position: { x: 205, y: 100 } },
  { id: 5, name: "Table 5", position: { x: 205, y: 150 } },
  { id: 6, name: "Table 6", position: { x: 125, y: 150 } },
  { id: 7, name: "Table 7", position: { x: 125, y: 100 } },
  { id: 8, name: "Table 8", position: { x: 125, y: 50 } },
  { id: 9, name: "Table 9", position: { x: 45, y: 50 } },
  { id: 10, name: "Table 10", position: { x: 45, y: 100 } },
  { id: 11, name: "Table 11", position: { x: 45, y: 150 } },
  { id: 12, name: "Table 12", position: { x: 200, y: 90 } },
  { id: 13, name: "Table 13", position: { x: 50, y: 90 } },
  { id: 14, name: "Table 14", position: { x: 50, y: 30 } },
  { id: 15, name: "Table 15", position: { x: 200, y: 30 } },
  { id: 16, name: "Table 16", position: { x: 200, y: 90 } },
  { id: 17, name: "Table 17", position: { x: 200, y: 30 } },
  { id: 18, name: "Table 18", position: { x: 50, y: 30 } },
  { id: 19, name: "Table 19", position: { x: 50, y: 90 } },
  { id: 20, name: "Table 20 (Outside)", position: { x: 50, y: 50 } },
  { id: 21, name: "Table 21 (Outside)", position: { x: 125, y: 100 } },
  { id: 22, name: "Table 22 (Outside)", position: { x: 50, y: 150 } },
  { id: 23, name: "Table 23 (Outside)", position: { x: 125, y: 200 } },
  { id: 24, name: "Table 24 (Outside)", position: { x: 50, y: 250 } },
  { id: 25, name: "Table 25 (Outside)", position: { x: 125, y: 300 } },
  { id: 26, name: "Table 26 (Outside)", position: { x: 50, y: 350 } },
  { id: 27, name: "Table 27 (Outside)", position: { x: 125, y: 400 } },
  { id: 28, name: "Table 28 (Outside)", position: { x: 50, y: 450 } },
  { id: 29, name: "Table 29 (Outside)", position: { x: 125, y: 500 } },
];
